import * as z from 'zod';

export const InvokeEditorFunctionRequest = z.object({
  functionId: z
    .string()
    .describe('Id of the function requested to be invoked')
    .regex(
      /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/,
      'Must be a valid GUID'
    ),
});
export const InvokeEditorFunctionResponse = z.object({
  output: z
    .record(z.string(), z.any())
    .describe(
      'The result data returned by the executed Editor Function. Structure depends on the specific function implementation.'
    )
    .optional()
    .nullable(),
});
